//schedule types

export const LOADING_EVENT_START = "LOADING_EVENT_START";
export const LOADING_EVENT_SUCCESS = "LOADING_EVENT_SUCCESS";
export const LOAD_EVENTS = "LOAD_EVENTS";
export const EDIT_EVENT = "EDIT_EVENT";
export const DELETE_EVENT = "DELETE_EVENT";
export const SET_ERROR = "SET_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const SAVE_NOT = "SAVE_NOT";
export const SAVE_SUCCESS = "SAVE_SUCCESS";
export const SET_RECENT_DATE = "SET_RECENT_DATE";

export const LOAD_FACILITIES = "LOAD_FACILITIES";
export const LOAD_WORK_TYPES = "LOAD_WORK_TYPES";
export const LOAD_EMPLOYEES = "LOAD_EMPLOYEES";
export const LOAD_WORKTYPE_EMPLOYEES = "LOAD_WORKTYPE_EMPLOYEES";
export const LOAD_LATEST_SELECTED_EVENT_DATA =
  "LOAD_LATEST_SELECTED_EVENT_DATA";
export const PATCH_EDITED_EVENT = "PATCH_EDITED_EVENT";
